/*
 * Blog Widgets
 * initialize any blog widgets after the DOM loads
 * 
 * 
 * 
 * 
 */
(function($) {
    
//    // initialize carousel widgets
//    $(".featured_listings_carousel .container").each( function() {
//        // get init options out of the custom data attributes on the elements
//        var options = {
//            autoplay: ( $(this).data("autoplay") == "Y"),
//            delay: $(this).data("delay")
//        };
//        $(this).carousel(options);
//    });
    
    
    // Ummm, what is this?!! 
    // the blog "more" links should go to the blog detail page, not toggle a summary vs full post in place...
    
    $('.blog_frame .post_body').on('click', '.blog_more', function(e) {
        $(this).parents('.post_body').find('.post_full').show();
        $(this).parents('.post_body').find('.post_snippet').hide();
    });
    
    
    $('.blog_frame .post_body').on('click', '.blog_less', function(e) {
        $(this).parents('.post_body').find('.post_snippet').show();
        $(this).parents('.post_body').find('.post_full').hide();
    });
    
   
    
})(jQuery);